export const isSupplier = (companyName: string) => companyName === 'SYSTEM-WIDE SUPPLIER TENANT';
